import React, { PureComponent } from 'react';
import { Icon } from './elements';

class GoldCrown extends PureComponent {
  render = (): React.ReactElement => {
    return (
      <Icon viewBox="0 0 29 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.925 21.875H5.075C4.67625 21.875 4.35 22.2266 4.35 22.6562V24.2188C4.35 24.6484 4.67625 25 5.075 25H23.925C24.3238 25 24.65 24.6484 24.65 24.2188V22.6562C24.65 22.2266 24.3238 21.875 23.925 21.875ZM26.825 6.25C25.6242 6.25 24.65 7.2998 24.65 8.59375C24.65 8.94043 24.7225 9.2627 24.8494 9.56055L21.5688 11.6797C20.8709 12.1289 19.9692 11.875 19.5659 11.1133L15.873 4.15039C16.3578 3.7207 16.675 3.07617 16.675 2.34375C16.675 1.0498 15.7008 0 14.5 0C13.2992 0 12.325 1.0498 12.325 2.34375C12.325 3.07617 12.6422 3.7207 13.127 4.15039L9.43406 11.1133C9.03078 11.875 8.12453 12.1289 7.43125 11.6797L4.15516 9.56055C4.2775 9.26758 4.35453 8.94043 4.35453 8.59375C4.35453 7.2998 3.38031 6.25 2.17953 6.25C0.97875 6.25 0 7.2998 0 8.59375C0 9.8877 0.974219 10.9375 2.175 10.9375C2.29281 10.9375 2.41063 10.918 2.52391 10.8984L5.8 20.3125H23.2L26.4761 10.8984C26.5894 10.918 26.7072 10.9375 26.825 10.9375C28.0258 10.9375 29 9.8877 29 8.59375C29 7.2998 28.0258 6.25 26.825 6.25Z"
          fill="#FFEE57"
        />
      </Icon>
    );
  };
}

export default GoldCrown;
